import * as api from '../coOpApi';
import {
  call,
  put,
  select,
  takeEvery
  } from 'redux-saga/effects';
import { coOpActionCreators, FetchCoOpRequests, ICoOpRequestApiResponse } from '..';
import { CoOpActionKeys } from '../coOpActionKeys';
import { getDefaultSalesDistricts } from '../../auth';
import { uiActionCreators } from '../../ui';

function* fetchCoOpRequests(action: FetchCoOpRequests) {
  yield put(uiActionCreators.toggleLoading('coOpRequests'));
  const sds: string[] = yield select(getDefaultSalesDistricts);

  const response: ICoOpRequestApiResponse = yield call(
    api.fetchCoOpRequests,
    sds,
    action.payload.fiscalYear,
    action.payload.finance
  );

  if (response) {
    yield put(coOpActionCreators.setRequests(response.requests));
    yield put(coOpActionCreators.setSalesDistrictBudgets(response.salesDistrictBudgets));
  }
  yield put(uiActionCreators.toggleLoading('coOpRequests'));
}

export function* watchFetchCoOpRequests() {
  yield takeEvery(CoOpActionKeys.FETCH_COOP_REQUESTS, fetchCoOpRequests);
}
